import { useNotesContext } from './useNotesContext';

export function useNotesSharePanel() {
    const {
        sharePanelOpen,
        setSharePanelOpen,
        openShareForNoteId,
        setOpenShareForNoteId,
        setShareSettingsForNoteBeingEdited
    } = useNotesContext();

    const openShareForNewNote = () => {
        setShareSettingsForNoteBeingEdited(null);
        setOpenShareForNoteId(null);
        setSharePanelOpen(true);
    };

    const openShareForExistingNote = (noteId: string) => {
        setShareSettingsForNoteBeingEdited(null);
        setOpenShareForNoteId(noteId);
        setSharePanelOpen(true);
    };

    const closeSharePanel = () => {
        setSharePanelOpen(false);
        setOpenShareForNoteId(null);
        setShareSettingsForNoteBeingEdited(null);
    };

    return {
        sharePanelOpen,
        openShareForNoteId,
        openShareForNewNote,
        openShareForExistingNote,
        closeSharePanel
    };
}
